import { render, staticRenderFns } from "./admin_tjwz.vue?vue&type=template&id=714157ae&scoped=true"
import script from "./admin_tjwz.vue?vue&type=script&lang=js"
export * from "./admin_tjwz.vue?vue&type=script&lang=js"
import style0 from "./admin_tjwz.vue?vue&type=style&index=0&id=714157ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714157ae",
  null
  
)

export default component.exports